export default "/images/vendor/flag-icons/flags/4x3/mo.svg?47a7b538e1eeb24ccfb481965a4a5f34";